import { jsonldCurrency } from './JsonldStore';

export const updateJsonldCurrency = (value) => jsonldCurrency.update((oldValue) => value);
